class AnimatableMixin {}
export default AnimatableMixin;
